document.addEventListener("DOMContentLoaded", function () {
  const button = document.querySelector(".scroll-to-top");

  if (button) {
    button.classList.remove("show");

    window.addEventListener("scroll", function () {
      if (window.scrollY > 200) {
        button.classList.add("show");
      } else {
        button.classList.remove("show");
      }
    });

    button.addEventListener("click", function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const productGrid = document.querySelector('.product-grid-layout');
  const listBtn = document.querySelector('.collection__layout-button[data-layout-mode="list"]');
  const gridBtn = document.querySelector('.collection__layout-button[data-layout-mode="grid"]');

  /* Shellback SEO 2026-08-22: null guards added. On product/cart/page templates
     these elements do not exist and the original code threw a TypeError, which
     aborted this listener and filled the console with noise that masked real
     errors. Behavior on collection pages is unchanged. */
  if (!productGrid) return;

  if (localStorage.getItem("layoutView") === "list") {
    productGrid.classList.add('grid-type--list_view');
  } else {
    productGrid.classList.remove('grid-type--list_view');
  }

  if (listBtn) {
    listBtn.addEventListener('click', function () {
      productGrid.classList.add('grid-type--list_view');
      localStorage.setItem("layoutView", "list");
    });
  }

  if (gridBtn) {
    gridBtn.addEventListener('click', function () {
      productGrid.classList.remove('grid-type--list_view');
      localStorage.setItem("layoutView", "grid");
    });
  }
});


/* ===== Shellback SEO: Add to Cart on listing pages - delegated (rewritten 2026-08-22) =====

   HISTORY
   The listing-page Add to Cart button is <button type="button" class="customBtn">, so it has
   no native form-post fallback: if JS has not bound it, clicking it does literally nothing.
   Binding was originally done per button by initInCustomBtn(), re-run via EventBus, and on
   2026-08-17 also via a MutationObserver attached to #product-grid.

   WHY IT KEPT COMING BACK (root cause of the 2026-08-21 recurrence)
   The 2026-08-17 observer was attached to the #product-grid ELEMENT that existed at page load.
   Globo Filter owns #ProductGridContainer (data-globo-filter-items) and re-renders it on every
   filter, sort and layout change, which REPLACES the #product-grid node. The observer was then
   watching a node detached from the document, and nothing ever re-ran the watcher setup, so
   every tile appended by infinite scroll after the first filter interaction was left unbound.
   The first 50 server-rendered tiles still worked, which is why the bug looked intermittent
   and customer-specific rather than reproducible.

   FIX
   Stop binding individual buttons. One delegated click listener on document handles every
   .customBtn that exists now or is ever injected, by any code path - infinite scroll, Globo
   re-render, quick view, or any future app. There is no node to go stale, so this cannot
   regress the same way.

   Notes:
   - initInCustomBtn() is kept as a safe no-op because layout/theme.liquid and other scripts
     still call it through EventBus; removing it would throw.
   - Per-button addEventListener was REMOVED. Leaving it alongside delegation would fire both
     handlers on one click and add the item to the cart twice.
   - data-sb-busy guards against double submits from a fast double-click.
   To revert: republish theme "PROD (Shellback) CartFix 2026-08-17". */

function initInCustomBtn() {
  /* Retained for backward compatibility only. Add to Cart is now bound by delegation
     below and needs no per-element initialization. Intentionally does nothing. */
}

(function () {
  function sbAddToCart(button) {
    if (button.getAttribute("data-sb-busy") === "true") return;

    var productBox = button.closest(".product-form");
    if (!productBox) return;

    var quantityInput = productBox.querySelector(".product-form__input.product-form__quantity");
    var selectElement = productBox.querySelector(".product-form__variants");

    if (!quantityInput || !selectElement) {
      console.warn("Add to Cart: missing quantity input or variant selector.");
      return;
    }

    var quantitybox = parseInt(quantityInput.value, 10) || 1;
    var variantId = selectElement.value;
    if (!variantId) {
      console.warn("Add to Cart: no variant selected.");
      return;
    }

    button.setAttribute("data-sb-busy", "true");

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantitybox
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error("cart/add.js returned " + response.status);
        return response.json();
      })
      .then(function () {
        button.classList.add("added");
        setTimeout(function () {
          button.classList.remove("added");
        }, 2000);

        // Open the native slide cart so the customer sees the item land.
        // Replaces closeDrwaerWhenAddItemInCollection(), which existed only to
        // suppress the Qikify drawer. Guarded so a missing drawer never breaks
        // the add itself.
        if (window.SBSlideCart && typeof window.SBSlideCart.openWithRefresh === "function") {
          window.SBSlideCart.openWithRefresh();
        }
      })
      .catch(function (error) {
        console.error("Error adding to cart:", error);
      })
      .finally(function () {
        button.removeAttribute("data-sb-busy");
      });
  }

  document.addEventListener("click", function (e) {
    if (!e.target || typeof e.target.closest !== "function") return;
    var button = e.target.closest(".customBtn");
    if (!button) return;
    if (button.disabled) return;
    e.preventDefault();
    sbAddToCart(button);
  });
})();

/* Retired 2026-08-22. This existed only to force-close the Qikify Slide Cart
   drawer after an add. Qikify is gone; the native drawer below is opened
   directly by the handler above. Kept as a no-op because other scripts may
   still reference the name. */
function closeDrwaerWhenAddItemInCollection() {}



document.addEventListener("DOMContentLoaded", function () {
  const resultsWrapper = document.querySelector("#SearchResultsWrapper");
  const loader = document.querySelector("#InfiniteScrollLoader");
  const urlHolder = document.querySelector("#data-pagination-url-set");

  if (!resultsWrapper || !urlHolder) return;

  let loading = false;
  let lastFetchedUrl = null;

  window.addEventListener("scroll", function () {
    const nextPageUrl = urlHolder.getAttribute("data-next-url");

    if (!nextPageUrl || nextPageUrl === lastFetchedUrl) return;

    if (
      window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 300 &&
      !loading
    ) {
      loading = true;
      if (loader) loader.style.display = "block";

      fetch(nextPageUrl)
        .then((res) => res.text())
        .then((data) => {
          const parser = new DOMParser();
          const htmlDoc = parser.parseFromString(data, "text/html");

          const newResultsWrapper = htmlDoc.querySelector("#SearchResultsWrapper");
          const newUrlHolder = htmlDoc.querySelector("#data-pagination-url-set");

          if (newResultsWrapper) {
            resultsWrapper.insertAdjacentHTML("beforeend", newResultsWrapper.innerHTML);
          }

          if (newUrlHolder) {
            const newPaginateUrl = newUrlHolder.getAttribute("data-next-url");
            if (newPaginateUrl) {
              urlHolder.setAttribute("data-next-url", newPaginateUrl);
            } else {
              urlHolder.removeAttribute("data-next-url");
            }
          } else {
            urlHolder.removeAttribute("data-next-url");
          }

          lastFetchedUrl = nextPageUrl;
          if (loader) loader.style.display = "none";
          loading = false;
        })
        .catch(() => {
          if (loader) loader.style.display = "none";
          loading = false;
        });
    }
  });
});

/* ===== Shellback SEO: partial-match search fix (added 2026-06-23) =====
   Appends a "*" wildcard to each typed search term so partial words match.
   Example: "trans" -> "trans*" returns Transmitter, Transformer, Transceiver.
   Applies to every storefront search form (action="/search"). The existing
   exact-match behavior is preserved (a full word + "*" still matches).
   To revert: delete this block only. */
(function () {
  function wildcardify(value) {
    if (!value) return value;
    var terms = value.trim().split(/\s+/);
    var out = [];
    for (var i = 0; i < terms.length; i++) {
      var t = terms[i];
      if (t === "") continue;
      out.push(t.charAt(t.length - 1) === "*" ? t : t + "*");
    }
    return out.join(" ");
  }
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || typeof form.getAttribute !== "function") return;
    if ((form.getAttribute("action") || "").indexOf("/search") === -1) return;
    var input = form.querySelector('input[name="q"]');
    if (!input || !input.value) return;
    var nv = wildcardify(input.value);
    if (nv !== input.value) input.value = nv;
  }, true);
})();

/* ==========================================================================
   Shellback SEO - Slide Cart  (added 2026-08-23)

   Native replacement for the Qikify Slide Cart app embed, which was left
   disabled after the 2026-08-02 incident where a Qikify flaw injected a fake
   checkout page on this store. NOTHING HERE LOADS THIRD-PARTY CODE. It talks
   only to Shopify's own /cart.js and /cart/change.js on this domain.

   Self-contained on purpose: styles, markup and logic all live in this file so
   the drawer needs no edit to layout/theme.liquid. custom.js is already loaded
   on every page, so dropping this in is the whole install.

   Public API: window.SBSlideCart.open() / .close() / .refresh() / .openWithRefresh()

   CHECKOUT ROUTING - deliberate:
   layout/theme.liquid contains the WPD block, which forces customers WITH TAGS
   to /cart instead of /checkout. That block binds on DOMContentLoaded and can
   never see this drawer's buttons, which are created later by JS. Customer tags
   are not exposed to JS, so the drawer cannot tell a tagged customer from an
   untagged one. It therefore routes to /cart for everyone, and the cart page
   applies whatever checkout rules already exist. This is one extra click and it
   is never wrong. A true one-click Checkout button would need a Liquid
   customer.tags test, i.e. an edit to layout/theme.liquid.

   To revert: delete this block from assets/custom.js. Everything above it is
   independent and keeps working. A copy of the pre-slide-cart file is saved in
   this theme as assets/BACKUP_2026-08-23_custom.js.pre-slidecart.txt
   ========================================================================== */
(function () {
  "use strict";

  if (window.SBSlideCart) return;

  // Shop money format, read from the Shopify Admin API on 2026-08-23.
  // If the store currency format is ever changed in Settings, update this.
  var cfg = {
    moneyFormat: "${{amount}}",
    cartUrl: "/cart",
    openOnHeaderClick: true,
    strings: {
      item: "item",
      items: "items",
      empty: "Your cart is empty.",
      continue: "Continue shopping",
      remove: "Remove",
      quantity: "Quantity",
      decrease: "Decrease quantity",
      increase: "Increase quantity",
      sku: "SKU",
      each: "ea",
      error: "Could not update the cart. Please try again."
    }
  };

  var CSS = `
/* ==========================================================================
   Shellback SEO - Slide Cart  (added 2026-08-22)
   Native replacement for the Qikify Slide Cart app embed. No third-party JS.
   ========================================================================== */

.sb-cart-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.25s ease, visibility 0.25s ease;
  z-index: 2147483000;
}
.sb-cart-overlay.is-open { opacity: 1; visibility: visible; }

.sb-cart {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 420px;
  background: #fff;
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 2147483001;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.18);
  font-size: 14px;
  color: #333;
  visibility: hidden;
  --sb-cart-accent: #006eff;
  --sb-cart-accent-text: #ffffff;
}
.sb-cart.is-open { transform: translateX(0); visibility: visible; }

.sb-cart *, .sb-cart *::before, .sb-cart *::after { box-sizing: border-box; }

.sb-cart__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  border-bottom: 1px solid #e6e6e6;
  flex: 0 0 auto;
}
.sb-cart__title {
  margin: 0;
  font-size: 16px;
  line-height: 1.2;
  font-weight: 700;
  color: #030303;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.sb-cart__count { font-weight: 400; color: #777; }
.sb-cart__close {
  background: none;
  border: 0;
  padding: 4px;
  margin: -4px;
  cursor: pointer;
  line-height: 0;
  color: #555;
  border-radius: 4px;
}
.sb-cart__close:hover { color: #000; }
.sb-cart__close svg { width: 18px; height: 18px; display: block; }

.sb-cart__body {
  flex: 1 1 auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 8px 20px;
}
.sb-cart__empty { padding: 48px 0; text-align: center; color: #777; }
.sb-cart__empty-title { font-size: 15px; color: #333; margin: 0 0 16px; }

.sb-cart__items { list-style: none; margin: 0; padding: 0; }
.sb-cart__item {
  display: flex;
  gap: 12px;
  padding: 16px 0;
  border-bottom: 1px solid #eee;
  align-items: flex-start;
}
.sb-cart__item:last-child { border-bottom: 0; }
.sb-cart__item.is-busy { opacity: 0.45; pointer-events: none; }

.sb-cart__image {
  flex: 0 0 64px;
  width: 64px;
  height: 64px;
  object-fit: contain;
  background: #f6f6f6;
  border: 1px solid #eee;
  border-radius: 3px;
}
.sb-cart__image--placeholder { display: block; }

.sb-cart__details { flex: 1 1 auto; min-width: 0; }
.sb-cart__name {
  display: block;
  color: #030303;
  font-weight: 600;
  line-height: 1.35;
  text-decoration: none;
  word-wrap: break-word;
}
.sb-cart__name:hover { text-decoration: underline; }
.sb-cart__variant, .sb-cart__sku {
  display: block;
  font-size: 12px;
  color: #888;
  margin-top: 3px;
}
.sb-cart__line-price { display: block; margin-top: 6px; font-weight: 600; color: #030303; }
.sb-cart__unit { font-weight: 400; color: #888; font-size: 12px; }

.sb-cart__qty-row { display: flex; align-items: center; gap: 12px; margin-top: 10px; }
.sb-cart__qty {
  display: inline-flex;
  align-items: center;
  border: 1px solid #d5d5d5;
  border-radius: 3px;
  overflow: hidden;
}
.sb-cart__qty-btn {
  background: #fafafa;
  border: 0;
  width: 30px;
  height: 30px;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  color: #333;
}
.sb-cart__qty-btn:hover { background: #efefef; }
.sb-cart__qty-input {
  width: 56px;
  min-width: 56px;
  max-width: none;
  height: 30px;
  padding: 0 4px;
  line-height: 30px;
  box-sizing: border-box;
  border: 0;
  border-left: 1px solid #d5d5d5;
  border-right: 1px solid #d5d5d5;
  text-align: center;
  font-size: 14px;
  color: #333;
  -moz-appearance: textfield;
  background: #fff;
}
.sb-cart__qty-input::-webkit-outer-spin-button,
.sb-cart__qty-input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
.sb-cart__remove {
  background: none;
  border: 0;
  padding: 0;
  font-size: 12px;
  color: #999;
  text-decoration: underline;
  cursor: pointer;
}
.sb-cart__remove:hover { color: #c0392b; }

.sb-cart__footer {
  flex: 0 0 auto;
  border-top: 1px solid #e6e6e6;
  padding: 16px 20px 20px;
  background: #fff;
}
.sb-cart__subtotal {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-size: 15px;
  font-weight: 700;
  color: #030303;
  margin-bottom: 4px;
}
.sb-cart__note { font-size: 12px; color: #888; margin: 0 0 14px; }
.sb-cart__actions { display: flex; flex-direction: column; gap: 8px; }
.sb-cart__btn {
  display: block;
  width: 100%;
  text-align: center;
  padding: 12px 16px;
  border-radius: 3px;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-decoration: none;
  cursor: pointer;
  border: 1px solid transparent;
  line-height: 1.2;
}
.sb-cart__btn--checkout {
  background: var(--sb-cart-accent, #006eff);
  color: var(--sb-cart-accent-text, #fff);
}
.sb-cart__btn--checkout:hover { filter: brightness(0.92); }
.sb-cart__btn--view {
  background: #fff;
  color: #030303;
  border-color: #d5d5d5;
}
.sb-cart__btn--view:hover { background: #f4f4f4; }

.sb-cart__loading {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.6);
  display: none;
}
.sb-cart.is-loading .sb-cart__loading { display: block; }
.sb-cart__error {
  display: none;
  margin: 12px 20px 0;
  padding: 10px 12px;
  background: #fdeaea;
  border: 1px solid #f5c2c2;
  color: #a33;
  font-size: 13px;
  border-radius: 3px;
}
.sb-cart__error.is-shown { display: block; }

.site-header__cart { position: relative; }

@media screen and (max-width: 480px) {
  .sb-cart { max-width: 100%; }
}

@media (prefers-reduced-motion: reduce) {
  .sb-cart, .sb-cart-overlay { transition: none; }
}

body.sb-cart-open { overflow: hidden; }
`;

  var MONEY_FORMAT = cfg.moneyFormat;
  var STR = cfg.strings || {};
  var ROOT = cfg.cartUrl || "/cart";

  function t(key, fallback) {
    return typeof STR[key] === "string" && STR[key] !== "" ? STR[key] : fallback;
  }

  /* ---------- money ---------- */
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = typeof precision === "undefined" ? 2 : precision;
    thousands = typeof thousands === "undefined" ? "," : thousands;
    decimal = typeof decimal === "undefined" ? "." : decimal;
    if (isNaN(number) || number === null) return "0";
    var n = (number / 100.0).toFixed(precision);
    var parts = n.split(".");
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
    var cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }

  function formatMoney(cents, format) {
    var fmt = format || MONEY_FORMAT;
    if (typeof cents === "string") cents = cents.replace(".", "");
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = fmt.match(placeholder);
    if (!match) return fmt;
    var value;
    switch (match[1]) {
      case "amount": value = formatWithDelimiters(cents, 2); break;
      case "amount_no_decimals": value = formatWithDelimiters(cents, 0); break;
      case "amount_with_comma_separator": value = formatWithDelimiters(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = formatWithDelimiters(cents, 0, ".", ","); break;
      case "amount_with_space_separator": value = formatWithDelimiters(cents, 2, " ", ","); break;
      case "amount_no_decimals_with_space_separator": value = formatWithDelimiters(cents, 0, " ", " "); break;
      case "amount_with_period_and_space_separator": value = formatWithDelimiters(cents, 2, " ", "."); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  /* ---------- escaping ---------- */
  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function sizedImage(src, size) {
    if (!src) return "";
    try {
      return src.replace(/(\.(?:png|jpg|jpeg|gif|webp))(\?.*)?$/i, "_" + size + "$1$2");
    } catch (e) {
      return src;
    }
  }

  /* ---------- injection ---------- */
  var MARKUP =
    '<div class="sb-cart-overlay" aria-hidden="true"></div>' +
    '<aside class="sb-cart" role="dialog" aria-modal="true" aria-label="Shopping cart" aria-hidden="true">' +
      '<div class="sb-cart__header">' +
        '<h2 class="sb-cart__title">Your cart <span class="sb-cart__count"></span></h2>' +
        '<button type="button" class="sb-cart__close" aria-label="Close cart">' +
          '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false">' +
            '<path d="M4 4l12 12M16 4L4 16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
          "</svg>" +
        "</button>" +
      "</div>" +
      '<div class="sb-cart__body"><div class="sb-cart__empty"><p class="sb-cart__empty-title">Loading&hellip;</p></div></div>' +
      '<p class="sb-cart__error" role="alert"></p>' +
      '<div class="sb-cart__footer" style="display:none;">' +
        '<div class="sb-cart__subtotal"><span>Subtotal</span><span data-sb-subtotal></span></div>' +
        '<p class="sb-cart__note">Shipping and taxes calculated at checkout.</p>' +
        '<div class="sb-cart__actions">' +
          '<a class="sb-cart__btn sb-cart__btn--checkout" href="/cart">View cart &amp; check out</a>' +
          '<button type="button" class="sb-cart__btn sb-cart__btn--view" data-sb-cart-close>Continue shopping</button>' +
        "</div>" +
      "</div>" +
    "</aside>";

  function inject() {
    if (!document.body) return false;
    if (!document.getElementById("sb-cart-styles")) {
      var style = document.createElement("style");
      style.id = "sb-cart-styles";
      style.textContent = CSS;
      (document.head || document.documentElement).appendChild(style);
    }
    if (!document.querySelector(".sb-cart")) {
      var host = document.createElement("div");
      host.id = "sb-cart-root";
      host.innerHTML = MARKUP;
      while (host.firstChild) document.body.appendChild(host.firstChild);
    }
    return true;
  }

  /* ---------- DOM refs ---------- */
  var overlay, drawer, body, footer, countEl, errorEl;
  var lastFocused = null;
  var isOpen = false;
  var built = false;

  function build() {
    if (built) return true;
    if (!inject()) return false;
    drawer = document.querySelector(".sb-cart");
    overlay = document.querySelector(".sb-cart-overlay");
    if (!drawer || !overlay) return false;
    body = drawer.querySelector(".sb-cart__body");
    footer = drawer.querySelector(".sb-cart__footer");
    countEl = drawer.querySelector(".sb-cart__count");
    errorEl = drawer.querySelector(".sb-cart__error");

    overlay.addEventListener("click", close);
    drawer.addEventListener("click", function (e) {
      if (e.target.closest(".sb-cart__close, [data-sb-cart-close]")) {
        e.preventDefault();
        close();
      }
    });
    document.addEventListener("keydown", onKeydown);
    built = true;
    return true;
  }

  function onKeydown(e) {
    if (!isOpen) return;
    if (e.key === "Escape" || e.key === "Esc") { close(); return; }
    if (e.key === "Tab") trapFocus(e);
  }

  function focusables() {
    if (!drawer) return [];
    return Array.prototype.filter.call(
      drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null || el === document.activeElement; }
    );
  }

  function trapFocus(e) {
    var list = focusables();
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- open / close ---------- */
  function open() {
    if (!build()) return;
    if (isOpen) return;
    lastFocused = document.activeElement;
    isOpen = true;
    overlay.classList.add("is-open");
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    overlay.setAttribute("aria-hidden", "false");
    document.body.classList.add("sb-cart-open");
    var closeBtn = drawer.querySelector(".sb-cart__close");
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!built || !isOpen) return;
    isOpen = false;
    overlay.classList.remove("is-open");
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    overlay.setAttribute("aria-hidden", "true");
    document.body.classList.remove("sb-cart-open");
    if (lastFocused && typeof lastFocused.focus === "function") {
      try { lastFocused.focus(); } catch (e) {}
    }
  }

  function showError(msg) { if (errorEl) { errorEl.textContent = msg; errorEl.classList.add("is-shown"); } }
  function clearError() { if (errorEl) { errorEl.textContent = ""; errorEl.classList.remove("is-shown"); } }

  /* ---------- rendering ---------- */
  function renderItem(item) {
    var img = item.image
      ? '<img class="sb-cart__image" src="' + esc(sizedImage(item.image, "160x160")) + '" alt="' + esc(item.product_title || item.title) + '" loading="lazy" width="64" height="64">'
      : '<span class="sb-cart__image sb-cart__image--placeholder" aria-hidden="true"></span>';

    var variant = "";
    if (item.variant_title && item.variant_title !== "Default Title") {
      variant = '<span class="sb-cart__variant">' + esc(item.variant_title) + "</span>";
    }
    var sku = item.sku ? '<span class="sb-cart__sku">' + esc(t("sku", "SKU") + ": " + item.sku) + "</span>" : "";
    var unit = item.quantity > 1
      ? ' <span class="sb-cart__unit">(' + esc(formatMoney(item.price)) + " " + esc(t("each", "ea")) + ")</span>"
      : "";

    return (
      '<li class="sb-cart__item" data-sb-key="' + esc(item.key) + '">' +
        '<a href="' + esc(item.url || "#") + '" tabindex="-1" aria-hidden="true">' + img + "</a>" +
        '<div class="sb-cart__details">' +
          '<a class="sb-cart__name" href="' + esc(item.url || "#") + '">' + esc(item.product_title || item.title) + "</a>" +
          variant + sku +
          '<span class="sb-cart__line-price">' + esc(formatMoney(item.final_line_price != null ? item.final_line_price : item.line_price)) + unit + "</span>" +
          '<div class="sb-cart__qty-row">' +
            '<div class="sb-cart__qty">' +
              '<button type="button" class="sb-cart__qty-btn" data-sb-step="-1" aria-label="' + esc(t("decrease", "Decrease quantity")) + '">&minus;</button>' +
              '<input class="sb-cart__qty-input" type="number" inputmode="numeric" min="0" step="1" value="' + esc(item.quantity) + '" aria-label="' + esc(t("quantity", "Quantity")) + '">' +
              '<button type="button" class="sb-cart__qty-btn" data-sb-step="1" aria-label="' + esc(t("increase", "Increase quantity")) + '">+</button>' +
            "</div>" +
            '<button type="button" class="sb-cart__remove" data-sb-remove>' + esc(t("remove", "Remove")) + "</button>" +
          "</div>" +
        "</div>" +
      "</li>"
    );
  }

  function render(cart) {
    if (!build()) return;
    clearError();

    var n = cart.item_count || 0;
    // Must run before the empty-cart early return, or the header dot stays lit
    // after the last line is removed.
    updateHeaderIndicator(n);

    if (countEl) {
      countEl.textContent = "(" + n + " " + (n === 1 ? t("item", "item") : t("items", "items")) + ")";
    }

    if (!cart.items || !cart.items.length) {
      body.innerHTML =
        '<div class="sb-cart__empty">' +
          '<p class="sb-cart__empty-title">' + esc(t("empty", "Your cart is empty.")) + "</p>" +
          '<button type="button" class="sb-cart__btn sb-cart__btn--view" data-sb-cart-close>' + esc(t("continue", "Continue shopping")) + "</button>" +
        "</div>";
      if (footer) footer.style.display = "none";
      return;
    }

    body.innerHTML = '<ul class="sb-cart__items">' + cart.items.map(renderItem).join("") + "</ul>";
    if (footer) {
      footer.style.display = "";
      var sub = footer.querySelector("[data-sb-subtotal]");
      if (sub) sub.textContent = formatMoney(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);
    }
  }

  function updateHeaderIndicator(count) {
    var dots = document.querySelectorAll(".site-header__cart-indicator");
    Array.prototype.forEach.call(dots, function (d) {
      if (count > 0) d.classList.remove("hide");
      else d.classList.add("hide");
    });
  }

  /* ---------- data ---------- */
  function getCart() {
    return fetch(ROOT + ".js", {
      method: "GET",
      credentials: "same-origin",
      headers: { Accept: "application/json" },
      cache: "no-store"
    }).then(function (r) {
      if (!r.ok) throw new Error("cart.js " + r.status);
      return r.json();
    });
  }

  // Serialised so rapid clicks cannot race each other on /cart/change.js, which
  // addresses lines by key and will misapply concurrent writes.
  var queue = Promise.resolve();
  function changeLine(key, quantity) {
    queue = queue
      .then(function () {
        return fetch(ROOT + "/change.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: key, quantity: quantity })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error("change.js " + r.status);
        return r.json();
      })
      .then(function (cart) { render(cart); publish(cart); })
      .catch(function (err) {
        console.error("Slide cart:", err);
        showError(t("error", "Could not update the cart. Please try again."));
        return refresh();
      });
    return queue;
  }

  function refresh() {
    return getCart()
      .then(function (cart) { render(cart); publish(cart); return cart; })
      .catch(function (err) {
        console.error("Slide cart:", err);
        showError(t("error", "Could not load the cart. Please try again."));
      });
  }

  function publish(cart) {
    try { document.dispatchEvent(new CustomEvent("sb:cart:updated", { detail: cart })); } catch (e) {}
  }

  function openWithRefresh() {
    open();
    if (drawer) drawer.classList.add("is-loading");
    return refresh().then(function (c) {
      if (drawer) drawer.classList.remove("is-loading");
      return c;
    });
  }

  /* ---------- interactions (delegated) ---------- */
  document.addEventListener("click", function (e) {
    if (!e.target || typeof e.target.closest !== "function") return;

    var stepBtn = e.target.closest(".sb-cart__qty-btn");
    if (stepBtn && drawer && drawer.contains(stepBtn)) {
      e.preventDefault();
      var li = stepBtn.closest(".sb-cart__item");
      if (!li) return;
      var input = li.querySelector(".sb-cart__qty-input");
      var step = parseInt(stepBtn.getAttribute("data-sb-step"), 10) || 0;
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + step);
      input.value = next;
      li.classList.add("is-busy");
      changeLine(li.getAttribute("data-sb-key"), next);
      return;
    }

    var removeBtn = e.target.closest("[data-sb-remove]");
    if (removeBtn && drawer && drawer.contains(removeBtn)) {
      e.preventDefault();
      var li2 = removeBtn.closest(".sb-cart__item");
      if (!li2) return;
      li2.classList.add("is-busy");
      changeLine(li2.getAttribute("data-sb-key"), 0);
      return;
    }

    // Header cart icon opens the drawer instead of navigating to /cart. It is a
    // real <a href="/cart">, so if this script ever fails the link still works.
    var cartLink = e.target.closest(".site-header__cart");
    if (cartLink && cfg.openOnHeaderClick !== false) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      openWithRefresh();
    }
  });

  document.addEventListener("change", function (e) {
    var input = e.target;
    if (!input.classList || !input.classList.contains("sb-cart__qty-input")) return;
    if (!drawer || !drawer.contains(input)) return;
    var li = input.closest(".sb-cart__item");
    if (!li) return;
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    input.value = qty;
    li.classList.add("is-busy");
    changeLine(li.getAttribute("data-sb-key"), qty);
  });

  /* ---------- product-page adds (passive) ----------
     theme.js posts to /cart/add.js through jQuery on product pages. ajaxSuccess
     is read-only: if jQuery is absent or the theme changes, it simply never
     fires and nothing breaks. */
  try {
    if (window.jQuery) {
      window.jQuery(document).on("ajaxSuccess", function (evt, xhr, settings) {
        if (((settings && settings.url) || "").indexOf("/cart/add") !== -1) openWithRefresh();
      });
    }
  } catch (e) {}

  window.SBSlideCart = {
    open: open,
    close: close,
    refresh: refresh,
    openWithRefresh: openWithRefresh,
    formatMoney: formatMoney,
    isOpen: function () { return isOpen; }
  };

  function init() {
    if (!build()) return;
    getCart().then(function (cart) { updateHeaderIndicator(cart.item_count || 0); }).catch(function () {});
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
